var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accessFailed"},[_c('div',{staticClass:"imgBox"},[_c('img',{staticClass:"img",attrs:{"src":require("@/assets/images/404.png"),"alt":""}}),_c('p',{staticClass:"msg"},[_vm._v(_vm._s(_vm.msg))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }